import React, {useMemo} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faRightFromBracket, faXmark} from "@fortawesome/free-solid-svg-icons";
import "./style.css";

function getInitials(name, email) {
  const source = (name || email || "").trim();
  if (!source) return "U";
  const parts = source.split(" ").filter(Boolean);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}

function LogoutModal({show, onClose, onConfirm, userDetails}) {
  const initials = useMemo(
      () => getInitials(userDetails?.name, userDetails?.email),
      [userDetails]
  );

  if (!show) return null;

  return (
      <div className="logoutOverlay" onMouseDown={onClose}>
        <div className="logoutModal" onMouseDown={(e) => e.stopPropagation()}>
          <button
              type="button"
              className="logoutClose"
              onClick={onClose}
              aria-label="Close"
          >
            <FontAwesomeIcon icon={faXmark}/>
          </button>

          <div className="logoutIconWrap">
            <FontAwesomeIcon icon={faRightFromBracket}/>
          </div>

          <h5 className="logoutTitle">Log out of your account?</h5>
          <p className="logoutSubtitle">
            You'll need to sign in again to access your dashboard and content.
          </p>

          {userDetails && (userDetails.name || userDetails.email) && (
              <div className="logoutUserCard">
                <span className="logoutAvatar">{initials}</span>
                <span className="logoutUserInfo">
              {userDetails.name && (
                  <span className="logoutUserName">{userDetails.name}</span>
              )}
                  {userDetails.email && (
                      <span className="logoutUserEmail">{userDetails.email}</span>
                  )}
            </span>
              </div>
          )}

          <div className="logoutActions">
            <button type="button" className="logoutCancelBtn" onClick={onClose}>
              Cancel
            </button>
            <button type="button" className="logoutConfirmBtn" onClick={onConfirm}>
              Logout
            </button>
          </div>
        </div>
      </div>
  );
}

export default LogoutModal;
